'use client';

import { useTranslations } from 'next-intl';
import { useTailwindBreakpoint } from '@headless-workspace/core-ui';
import { ProductInfoTabParamsValue } from '@headless-workspace/domain/common/server';
import { GlowTabsProps, GlowTabs, typographyStyle } from '@headless-workspace/glow-ds';
import { tailwindTheme } from '@headless-workspace/theme';
import { Component } from '@headless-workspace/typings';
import { PredicateHelpers } from '@headless-workspace/utils';
import { VariantProps } from 'class-variance-authority';
import { ProductInfoTabsContent } from './ProductInfoTabsContent';

type ProductInfoTabsProps = {
    productInfoTabs: ProductInfoTabParamsValue[];
    openTabWithId?: string;
    fontFamily?: VariantProps<typeof typographyStyle>['fontFamily'];
};

const PRODUCT_INFO_TAB = 'productInfoTab';
const PRODUCT_DETAIL_INFO_MODAL_ID = 'product-detail-info-modal';

export const ProductInfoTabs: Component<ProductInfoTabsProps> = ({ productInfoTabs, openTabWithId, fontFamily }) => {
    const t = useTranslations();
    const defaultIndex = productInfoTabs.findIndex((item) => item?.id === openTabWithId);

    const generateTabs = (tabs: ProductInfoTabParamsValue[]) => {
        return tabs
            .map((productInfoTab) => {
                if (!productInfoTab.value.content) {
                    return null;
                }
                return {
                    label: t(productInfoTab.label),
                    fontFamily: fontFamily,
                    Content: () => <ProductInfoTabsContent productInfoTab={productInfoTab} fontFamily={fontFamily} />,
                };
            })
            .filter(PredicateHelpers.notNullOrUndefined);
    };

    const productTab: GlowTabsProps = {
        id: PRODUCT_INFO_TAB,
        previousButtonAriaLabel: t('Discover.Pdp.productInfo.productTab.ariaLabel.previousButton'),
        nextButtonAriaLabel: t('Discover.Pdp.productInfo.productTab.ariaLabel.nextButton'),
        defaultIndex,
        tabs: generateTabs(productInfoTabs),
    };

    // HACK MOBILE: to display close btn always sticky in mobile
    const productDetailInfoModal = document.getElementById(PRODUCT_DETAIL_INFO_MODAL_ID);
    const isMobile = useTailwindBreakpoint('tablet', false, true);

    if (isMobile && productDetailInfoModal) {
        productDetailInfoModal.style.height = tailwindTheme.height.dynamicViewportHeight;
    }

    return <GlowTabs {...productTab} />;
};
